<template>
  <div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0" v-if="!idEdit">
                  Realize seu cadastro de jurado
                </h3>
                <h3 class="mb-0" v-else>Cadastro de Jurado</h3>
              </b-col>
              <b-col cols="4" v-loading="loading" />
            </b-row>

            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form @submit.prevent="handleSubmit(save)" v-loading="loading">
                <!-- Dados de Acesso -->
                <h6 class="heading-small text-muted mb-4">Dados da Conta</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Nome"
                        name="Nome"
                        placeholder="Digite o seu nome"
                        v-model="user.nome"
                        rules="required"
                      >
                      </base-input>
                    </b-col>

                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Empresa"
                        name="Empresa"
                        placeholder="Digite o nome da sua empresa"
                        v-model="user.empresa"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="email"
                        label="E-mail de Acesso"
                        name="E-mail de Acesso"
                        placeholder="Digite o seu e-mail de acesso"
                        v-model="user.emailAcesso"
                        rules="required"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="password"
                        label="Senha"
                        name="Senha"
                        placeholder="Digite a sua senha"
                        v-model="user.senha"
                        rules="required"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <div
                  class="pl-lg-4 d-flex justify-content-end align-items-center"
                >
                  <span class="text-danger mr-3">{{ errorFeedback }}</span>
                  <base-button
                    type="primary"
                    native-type="submit"
                    :loading="loading"
                    class="my-4"
                  >
                    <span v-if="!idEdit">Cadastrar</span>
                    <span v-else>Salvar</span>
                  </base-button>
                </div>
              </b-form>
            </validation-observer>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";
import { login } from "@/services/utils";

export default {
  name: "jurado-form",
  props: {
    userForm: Boolean,
  },
  data() {
    return {
      errorFeedback: "",
      loading: false,
      idEdit: null,
      user: {
        id: "",
        emailAcesso: "",
        empresa: "",
        nome: "",
        senha: "",
      },
    };
  },
  methods: {
    login,
    setLoading(loading) {
      this.loading = loading;
    },
    successLogin() {
      this.$router.push("/jurado/home");
    },
    errorLogin() {
      this.errorFeedback =
        "Ocorreu algum problema ao fazer login com o usuário criado.";
    },
    async save() {
      this.errorFeedback = "";
      this.loading = true;
      try {
        await api.post("/jurado", this.user);

        if (this.userForm) {
          this.errorFeedback = "";
          login(
            this.user.emailAcesso,
            this.user.senha,
            this.setLoading,
            this.successLogin,
            this.errorLogin,
            true
          );
        }
      } catch (e) {
        this.errorFeedback =
          "Ocorreu um problema. Por favor, tente novamente mais tarde.";
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.idEdit = this.$route.params.id;
    if (this.idEdit) {
      this.loading = true;
      try {
        const response = await api.get(`/jurado/${this.idEdit}`);
        this.data = response.data;
      } catch (e) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao carregar os dados. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
<style></style>
